// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS202: Simplify dynamic range loops
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import * as d3 from 'd3';
import {Selection} from 'd3';

import * as selectioncontextmenu from 'components/SelectionContextMenu';
import * as context from 'Context';
import {RingLayout} from 'molbio/maps/circular/CircularLayout';
import {
  getHiddenBackgroundPath,
  getLinePath,
  getStartPositionFlagPath,
  getStartPositionTickPath,
} from 'molbio/maps/circular/CircularORFUtil';
import {HasRadius} from 'molbio/maps/circular/CircularTypedefs';
import SegmentsRingView, {SegmentRingSelection} from 'molbio/maps/circular/SegmentsRingView';
import {SequenceMapPreferences} from 'molbio/maps/SequenceMapConstants';
import ORF from 'molbio/translations/backbone/ORF';
import preferences from 'Preferences';

class CircularORFsView extends SegmentsRingView<RingLayout, ORF> {
  className!: string;
  singularClassName!: string;

  static initClass(): void {
    this.prototype.className = 'orfs';
    this.prototype.singularClassName = 'orf';
    this.prototype.tagName = 'g';
  }

  contextMenuData(): Array<string> {
    return selectioncontextmenu.getSelectionMenu();
  }

  fill(d: ORF): string {
    if (d.get('hover') || d.selected()) {
      return d3.rgb(d.color()).darker().formatHex();
    } else {
      return d.color();
    }
  }

  opacity(d: ORF): number {
    return 1.0;
  }

  strokeWidth(d: ORF): number {
    return 1.0;
  }

  stroke(d: ORF): string {
    return d.color();
  }

  handleHover(model: ORF, value: unknown): unknown {
    const id = model.uid();
    const root = d3.select(this.el).selectAll('.individual-ring').filter(`[id='${id}']`);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    root.select('.line').transition().duration(25).attr('fill-opacity', this.opacity).attr('fill', 'none');

    return (
      root
        .selectAll('.start-position')
        .transition()
        .duration(25)
        // eslint-disable-next-line @typescript-eslint/unbound-method
        .attr('fill-opacity', this.opacity)
        // eslint-disable-next-line @typescript-eslint/unbound-method
        .attr('fill', this.fill)
    );
  }

  // @ts-expect-error: Improperly extends super interface
  handleDraw(selector: Selection<SVGGElement, ORF, SVGGElement, unknown>, d: ORF): void {
    let i;
    const sequence = this.model.get('sequence');
    const line = selector.selectAll('.line');

    line.data([d]);
    line.attr(
      'd',
      ((ref) =>
        function (d: ORF) {
          return getLinePath({
            angles: ref.getAngles(d.start(), d.end()),
            layer: d.get('annularLayer'),
            radiusIn: ref.radiusIn,
            vMargin: ref.layout.vMargin(),
          });
        })(this)
    );

    const background = selector.selectAll('.hidden-background');
    background.attr(
      'd',
      ((ref) =>
        function (d: ORF) {
          return getHiddenBackgroundPath({
            angles: ref.getAngles(d.start(), d.end()),
            layer: d.get('annularLayer'),
            orf: d,
            radiusIn: ref.radiusIn,
          });
        })(this)
    );

    const starts = d.startPositions();
    // @ts-expect-error: Unused variable
    const ends = d.endPosition() != null ? [d.endPosition()] : [];

    const dataArray = (() => {
      const result = [];
      for (i = 0; i < starts.length; i++) {
        result.push(d);
      }
      return result;
    })();
    const positions = selector.selectAll('path.start-position').data(dataArray);
    positions
      .enter()
      .append('svg:path')
      .classed('start-position', true)
      .classed('layer-fill', true)
      // eslint-disable-next-line @typescript-eslint/unbound-method
      .attr('fill', this.fill)
      // eslint-disable-next-line @typescript-eslint/unbound-method
      .attr('fill-opacity', this.opacity)
      .attr('shape-rendering', 'geometricPrecision')
      // eslint-disable-next-line @typescript-eslint/unbound-method
      .attr('stroke-width', this.strokeWidth)
      .attr('stroke', 'green');
    const circumferenceRadians = 2 * Math.PI;
    const circumferencePixels = circumferenceRadians * this.layout.get('innerRadius');
    const sequenceLengthCodons = sequence.length() / 3;
    const pixelsPerCodon = circumferencePixels / sequenceLengthCodons;

    // We want the start position indicator to be the width of a codon. If a codon would be less than three
    // pixels wide when rendered at the current zoom, display a thin vertical tick at each start position
    // instead of a flag.
    const displayFlagThreshold = 3;
    if (pixelsPerCodon > displayFlagThreshold) {
      positions.attr(
        'd',
        ((ref) =>
          function (d: ORF, index: number) {
            return getStartPositionFlagPath({
              basePairToAngle: (basePair: number) => ref.basePairToAngle(basePair),
              index,
              layer: d.get('annularLayer'),
              orf: d,
              radiusIn: ref.radiusIn,
              sequenceLength: sequence.length(),
              vMargin: ref.layout.vMargin(),
            });
          })(this)
      );
    } else {
      positions.attr(
        'd',
        ((ref) =>
          function (d: ORF, index: number) {
            return getStartPositionTickPath({
              basePairToAngle: (basePair: number) => ref.basePairToAngle(basePair),
              index,
              layer: d.get('annularLayer'),
              orf: d,
              radiusIn: ref.radiusIn,
              sequenceLength: sequence.length(),
              vMargin: ref.layout.vMargin(),
            });
          })(this)
      );
    }

    positions.exit().remove();
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    return this.registerPieceHandlers(selector);
  }

  pieceClickHandler(e: Event, d: ORF): void {
    const index = this.circularView.getHoverBase(e, false);
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    return context.using({isLinear: this.isLinear, mapId: this.model.cid, index}, this, function () {
      // @ts-expect-error: Shadowing of this
      return this.clickAction(e, d);
    });
  }

  pieceDblClickHandler(e: Event, d: ORF): void {
    const index = this.circularView.getHoverBase(e, false);
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    return context.using({isLinear: this.isLinear, mapId: this.model.cid, index}, this, function () {
      // @ts-expect-error: Shadowing of this
      return this.dblClickAction(e, d);
    });
  }

  enterRing(enter: SegmentRingSelection<ORF>): SegmentRingSelection<ORF> {
    const ring = enter.append('svg:g').classed('ring-shape', true).merge(enter) as SegmentRingSelection<ORF>;
    ring
      .append('svg:path')
      .classed('line', true)
      .classed(this.singularClassName, true)
      // eslint-disable-next-line @typescript-eslint/unbound-method
      .attr('stroke-width', this.strokeWidth)
      // eslint-disable-next-line @typescript-eslint/unbound-method
      .attr('stroke', this.stroke)
      .attr('shape-rendering', 'geometricPrecision')
      .attr('fill', 'none')
      // eslint-disable-next-line @typescript-eslint/unbound-method
      .attr('fill-opacity', this.opacity);

    ring.append('svg:path').classed('hidden-background', true).attr('fill-opacity', 0);

    return ring;
  }

  data(): Array<ORF> {
    const sequence = this.model.get('sequence');
    const length = sequence.length();
    // TODO: Use preference values here. Right now it doesn't matter because visibility options will
    // trigger another re-render with updated values for all options, but they will be incorrect on the first
    // render which will cause an error in `sliceAndFilter` (which depends on `startCodon`).
    const option = this.tabstate.get('visibilityOptions').getOption('orfs');
    const minLength = option!.getSetting('minimum-orf-length')!.get('value');
    const frame = option!.getSetting('orf-frame')!.get('value');
    // Generally visibility options control what data is rendered (and when to re-render), but visibility
    // options are also synced to preferences which is why we can use that here.
    const startCodon = preferences.get(SequenceMapPreferences.ORF_START_CODON);
    const options = {minLength, frame, sequence, startCodon};
    return sequence.get('orfs').sliceAndFilter(0, length, options);
  }

  registerListeners(): void {
    super.registerListeners();

    const orfs = this.model.get('sequence').get('orfs');
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(orfs, 'change:hover change:selected', this.handleHover);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(orfs, 'click', this.pieceClickHandler);
  }

  setConstraints(outerRadius: number): void {
    this.setOuterRadius(outerRadius);
  }

  clickAction(e: Event, d: ORF): void {
    d.click(this.model.get('sequence'), false);
  }

  dblClickAction(e: Event, d: ORF): void {
    d.dblClick(this.model.get('sequence'), false);
  }

  redraw(): void {
    this.invalidateData();
    super.redraw();
  }

  redrawPlasmid(): boolean {
    return true;
  }

  storeBounds(rings: number | null | undefined): void {
    if (rings == null) {
      ({rings} = this);
    }
    this.rings = rings;
    const innerRadius = this.getOuterRadius() - this.layout.get('ringHeight') * this.rings!;
    this.layout.set('innerRadius', innerRadius);
    this.updateRadius();
  }

  zeroBounds(): void {
    this.layout.set('innerRadius', this.layout.get('outerRadius'));
    this.updateRadius();
  }

  layerBounds(layer: number): HasRadius {
    return {
      innerRadius: this.radiusIn(layer + 1),
      outerRadius: this.radiusIn(layer) - this.layout.vMargin(),
    };
  }

  baseLine(layer: number, innerRadius: number | null = null): number {
    if (innerRadius != null) {
      // @ts-expect-error: unused arg
      return super.baseLine(layer, innerRadius);
    } else {
      return this.radiusIn(layer + 1);
    }
  }
}

CircularORFsView.initClass();

export default CircularORFsView;
